/** Fixed simulation rate. Engine constant, not a balance number. */
export const TICK_RATE = 30

/** Convert milliseconds to whole ticks, rounding up so a duration is never shortened. */
export function msToTicks(ms: number): number {
  return Math.ceil((ms * TICK_RATE) / 1000)
}

export function secToTicks(sec: number): number {
  return msToTicks(sec * 1000)
}

/** px/s → px/tick. */
export function perSecToPerTick(pxPerSec: number): number {
  return pxPerSec / TICK_RATE
}

/** px/s² → px/tick². */
export function perSec2ToPerTick2(pxPerSec2: number): number {
  return pxPerSec2 / (TICK_RATE * TICK_RATE)
}
